// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AnalyticsChartController from "./analytics_chart_controller"
application.register("analytics-chart", AnalyticsChartController)

import AlertController from "./alert_controller"
application.register("alert", AlertController)

import AppleController from "./apple_controller"
application.register("apple", AppleController)

import AutoFocusController from "./auto_focus_controller"
application.register("auto-focus", AutoFocusController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import AvatarController from "./avatar_controller"
application.register("avatar", AvatarController)

import BillingFormController from "./billing_form_controller"
application.register("billing-form", BillingFormController)

import ChatController from "./chat_controller"
application.register("chat", ChatController)

import ChatSidebarController from "./chat_sidebar_controller"
application.register("chat-sidebar", ChatSidebarController)

import ClickMapperController from "./click_mapper_controller"
application.register("click-mapper", ClickMapperController)

import ConfirmationController from "./confirmation_controller"
application.register("confirmation", ConfirmationController)

import ContactIntentController from "./contact_intent_controller"
application.register("contact-intent", ContactIntentController)

import CopyController from "./copy_controller"
application.register("copy", CopyController)

import CurrencyInputController from "./currency_input_controller"
application.register("currency-input", CurrencyInputController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import DirectoryController from "./directory_controller"
application.register("directory", DirectoryController)

import DisableAttachmentsTrixController from "./disable_attachments_trix_controller"
application.register("disable-attachments-trix", DisableAttachmentsTrixController)

import DisappearController from "./disappear_controller"
application.register("disappear", DisappearController)

import DropzoneController from "./dropzone_controller"
application.register("dropzone", DropzoneController)

import EchoFormController from "./echo_form_controller"
application.register("echo-form", EchoFormController)

import FaqController from "./faq_controller"
application.register("faq", FaqController)

import GalleryController from "./gallery_controller"
application.register("gallery", GalleryController)

import ImageZoomController from "./image_zoom_controller"
application.register("image-zoom", ImageZoomController)

import HiddenTextController from "./hidden_text_controller"
application.register("hidden-text", HiddenTextController)

import HomeOffersController from "./home_offers_controller"
application.register("home-offers", HomeOffersController)

import HowItWorksController from "./how_it_works_controller"
application.register("how-it-works", HowItWorksController)

import JobFormController from "./job_form_controller"
application.register("job-form", JobFormController)

import LandingController from "./landing_controller"
application.register("landing", LandingController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import ModalOpenerController from "./modal_opener_controller"
application.register("modal-opener", ModalOpenerController)

import ProductImpressionController from "./product_impression_controller"
application.register("product-impression", ProductImpressionController)

import ProductSwiperController from "./product_swiper_controller"
application.register("product-swiper", ProductSwiperController)

import ProblemGuideController from "./problem_guide_controller"
application.register("problem-guide", ProblemGuideController)

import ProblemIndexController from "./problem_index_controller"
application.register("problem-index", ProblemIndexController)

import ProfessionSearchController from "./profession_search_controller"
application.register("profession-search", ProfessionSearchController)

import ProfileCardColorPickerController from "./profile_card_color_picker_controller"
application.register("profile-card-color-picker", ProfileCardColorPickerController)

import ProfileCardController from "./profile_card_controller"
application.register("profile-card", ProfileCardController)

import ProfileEditorController from "./profile_editor_controller"
application.register("profile-editor", ProfileEditorController)

import ProfileProfessionsController from "./profile_professions_controller"
application.register("profile-professions", ProfileProfessionsController)

import ProfileServicesSearchController from "./profile_services_search_controller"
application.register("profile-services-search", ProfileServicesSearchController)

import ProjectSearchController from "./project_search_controller"
application.register("project-search", ProjectSearchController)

import ProviderFeaturesSwiperController from "./provider_features_swiper_controller"
application.register("provider-features-swiper", ProviderFeaturesSwiperController)

import ProviderJobsSwiperController from "./provider_jobs_swiper_controller"
application.register("provider-jobs-swiper", ProviderJobsSwiperController)

import RecentJobsController from "./recent_jobs_controller"
application.register("recent-jobs", RecentJobsController)

import RelatedServicesPickerController from "./related_services_picker_controller"
application.register("related-services-picker", RelatedServicesPickerController)

import ResetFormController from "./reset_form_controller"
application.register("reset-form", ResetFormController)

import ReviewFormController from "./review_form_controller"
application.register("review-form", ReviewFormController)

import ScreenshotController from "./screenshot_controller"
application.register("screenshot", ScreenshotController)

import ScrollController from "./scroll_controller"
application.register("scroll", ScrollController)

import ScrollableController from "./scrollable_controller"
application.register("scrollable", ScrollableController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import SearchFocusController from "./search_focus_controller"
application.register("search-focus", SearchFocusController)

import SelectController from "./select_controller"
application.register("select", SelectController)

import ServicesEditorController from "./services_editor_controller"
application.register("services-editor", ServicesEditorController)

import ShareController from "./share_controller"
application.register("share", ShareController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import StarRatingController from "./star_rating_controller"
application.register("star-rating", StarRatingController)

import SwiperController from "./swiper_controller"
application.register("swiper", SwiperController)

import TextClipController from "./text_clip_controller"
application.register("text-clip", TextClipController)

import WebpushController from "./webpush_controller"
application.register("webpush", WebpushController)

import WorkActivityNotificationsController from "./work_activity_notifications_controller"
application.register("work-activity-notifications", WorkActivityNotificationsController)
